import React, { Component } from 'react';
import { NavLink, Link } from 'react-router-dom';
import Drawer from 'react-motion-drawer';

class Header extends React.Component { 
    constructor(props){
        super(props);
        this.state = {
            isMenuOpen: false,
            isMobile: false,
        }

        this.nav = null;
    }
    
    componentDidMount() {

        /* 
            mobile Size Check 768
        */

        // 1. initial check
        let winWid = window.innerWidth;
        if(this.state.isMobile){
            if(winWid > 768){
                this.setState({
                    isMobile: false
                });
            }
        } else {
            if(winWid <= 768){
                this.setState({
                    isMobile: true
                });
            }

        }

        // 2. resize check 
        let _this = this; //안에서 this 사용하기 위함
        window.addEventListener('resize', function(){
            let winWid = window.innerWidth;

            if(_this.state.isMobile){
                if(winWid > 768){
                    _this.setState({
                        isMobile: false
                    });
                }
            } else {
                if(winWid <= 768){
                    _this.setState({
                        isMobile: true
                    });
                }
            }
        });


    }

    menuToggle = () => {

        this.setState({
            isMenuOpen: !this.state.isMenuOpen
        });
    }


    render(){
        return (
            <header>

                <Link to="/">
                    <h1 className="logo">CHINAMAGIC</h1>
                </Link>

                {this.state.isMobile ? 
                <button className={`${!this.state.isMenuOpen ? '' : 'active'} menu`} onClick={this.menuToggle}>
                    <span className="line"></span>
                    <span className="hide">Menu</span>
                </button>
                :
                null
                }

                <nav ref={nav => this.nav = nav}>
                    <ul>
                        <li><NavLink onClick={this.menuToggle} exact to="/" activeClass="active">Home</NavLink></li>
                        <li><NavLink onClick={this.menuToggle} to="/About" activeClass="active">소개</NavLink></li>
                        <li><NavLink onClick={this.menuToggle} to="/Work" activeClass="active">공연사진</NavLink></li>
                        <li><NavLink onClick={this.menuToggle} to="/Contact" activeClass="active">공연문의</NavLink></li>
                        <li><a href="https://smartstore.naver.com/chinamagic8" rel="noopener noreferrer" target="_blank" activeClass="active">매직샵</a></li>
                    </ul>
                </nav>


                {this.state.isMobile ?
                <Drawer open={this.state.isMenuOpen} onChange={open => this.setState({isMenuOpen : open})}>
                <nav className="mnav" ref={nav => this.nav = nav}>
                    <ul>
                        <li><NavLink onClick={this.menuToggle} exact to="/" activeClassName="active">Home</NavLink></li>
                        <li><NavLink onClick={this.menuToggle} to="/About" activeClassName="active">소개</NavLink></li>
                        <li><NavLink onClick={this.menuToggle} to="/Work" activeClassName="active">공연사진</NavLink></li>
                        <li><NavLink onClick={this.menuToggle} to="/Contact" activeClassName="active">공연문의</NavLink></li>
                        <li><a href="https://smartstore.naver.com/chinamagic8" rel="noopener noreferrer" target="_blank" activeClassName="active">매직샵</a></li>
                    </ul>
                    <button className="nav_close" onClick={this.menuToggle}><span className="hide">Close Nav</span></button>
                </nav>
                </Drawer>
                :null}


            </header>
        )
    }

};

export default Header;